// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var financeRouter = {
  path: '/finance',
  component: Layout,
  redirect: '/finance/closingSetting',
  name: 'Financial',
  meta: {
    title: '财务',
    icon: 'clipboard'
  },
  children: [{
    path: 'statement',
    name: 'FinanceStatement',
    meta: {
      title: '账单管理',
      noCache: true
    },
    component: function component() {
      return import('@/views/finance/statement/index');
    }
  }, {
    path: 'closingSetting',
    component: function component() {
      return import('@/views/finance/setting/index');
    },
    name: 'ClosingSetting',
    meta: {
      title: '商户结算设置',
      icon: ''
    }
  }, {
    path: 'closing',
    component: function component() {
      return import('@/views/finance/closing/index');
    },
    name: 'FinancialClosing',
    meta: {
      title: '结算管理',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'merchantClosing',
      component: function component() {
        return import('@/views/finance/closing/merchantClosing/index');
      },
      name: 'MerchantClosing',
      meta: {
        title: '商户结算',
        icon: ''
      }
    }, {
      path: 'userClosing',
      component: function component() {
        return import('@/views/finance/closing/userClosing/index');
      },
      name: 'UserClosing',
      meta: {
        title: '用户结算',
        icon: ''
      }
    }]
  }, {
    path: 'charge',
    component: function component() {
      return import('@/views/finance/charge/index');
    },
    name: 'FinanceCharge',
    meta: {
      title: '充值记录',
      icon: ''
    }
  }, {
    path: 'journalAccount',
    component: function component() {
      return import('@/views/finance/journalAccount/index');
    },
    name: 'FinanceJournalAccount',
    meta: {
      title: '流水管理',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'capitalFlow',
      name: 'FinanceCapitalFlow',
      meta: {
        title: '资金流水',
        noCache: true
      },
      component: function component() {
        return import('@/views/finance/journalAccount/capitalFlow/index');
      }
    }, {
      path: 'summaryCapitalFlow',
      component: function component() {
        return import('@/views/finance/journalAccount/summaryCapitalFlow/index');
      },
      name: 'SummaryCapitalFlow',
      meta: {
        title: '流水汇总',
        icon: ''
      }
    }]
  }, {
    path: 'profit_sharing',
    component: function component() {
      return import('@/views/finance/profit_sharing/index');
    },
    name: 'ProfitSharing',
    meta: {
      title: '分账记录',
      icon: ''
    }
  }, {
    path: 'lakala',
    component: function component() {
      return import('@/views/finance/lakala/index');
    },
    name: 'Lakala',
    meta: {
      title: '拉卡拉',
      icon: ''
    },
    redirect: '/finance/lakala/account',
    alwaysShow: true,
    children: [{
      path: 'account',
      component: function component() {
        return import('@/views/finance/lakala/account/index');
      },
      name: 'LakalaAccount',
      meta: {
        title: '拉卡拉资金账户管理',
        icon: ''
      }
    }, {
      path: 'sharing',
      component: function component() {
        return import('@/views/finance/lakala/sharing/index');
      },
      name: 'LakalaSharing',
      meta: {
        title: '渠道合作商资金账户管理',
        icon: ''
      }
    }, {
      path: 'bind',
      component: function component() {
        return import('@/views/finance/lakala/bind/index');
      },
      name: 'LakalaBind',
      meta: {
        title: '绑定申请台账',
        icon: ''
      }
    }]
  }, {
    path: 'payment',
    component: function component() {
      return import('@/views/finance/payment/index');
    },
    name: 'FinancePayment',
    meta: {
      title: '支付单管理',
      icon: ''
    }
  }, {
    path: 'counter_order',
    component: function component() {
      return import('@/views/finance/counter_order/index');
    },
    name: 'CounterOrder',
    meta: {
      title: '收银台订单',
      icon: ''
    }
  }, {
    path: 'pending',
    component: function component() {
      return import('@/views/finance/pending/index');
    },
    name: 'FinancePending',
    meta: {
      title: '平台签约管理',
      icon: ''
    }
  }, {
    path: 'dashboard',
    component: function component() {
      return import('@/views/dashboard/offline/index');
    },
    name: 'OfflineDashboard',
    meta: {
      title: '线下订单驾驶舱',
      icon: ''
    }
  }]
};
export default financeRouter;